var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_18_1657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 9.00009H12.1L12.2 11.0001L16 7.80011L12.1 4.6001V6.7001H8.5V9.00009Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.59998 13.1C4.69998 13.1 2.29996 10.7 2.29996 7.80005C2.29996 4.90005 4.69998 2.50003 7.59998 2.50003C9.09998 2.50003 10.3 3.00003 11.3 4.00003C11.8 3.50003 12.4 2.80002 12.9 2.40002C11.6 1.10002 9.69998 0.300049 7.69998 0.300049C3.59998 0.300049 0.0999756 3.60002 0.0999756 7.90002C0.0999756 12 3.39998 15.5 7.69998 15.5C9.79998 15.5 11.7 14.7 13 13.4L11.4 11.8C10.4 12.6 8.99998 13.1 7.59998 13.1Z",
    fill: "#EB5757"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f6745fd2388d6f790b625291f6388070.exit.f6745fd2388d6f790b625291f6388070.svg";
export { ForwardRef as ReactComponent };